import { ThemeExtension } from '@liscio/ui';

/**
 * Overrides to get us closer to the ideal desktop theme using this figma as a reference:
 * https://www.figma.com/design/aeBX5Q4JVM8lRqS1ZhZGCC/Design-system-components?node-id=1323-19631&node-type=symbol&m=dev
 */
export const desktopComponents: ThemeExtension = () => ({});
